import React, { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { FormattedMessage } from 'react-intl';

interface IProps {
  showCursor?: boolean;
  showEnter?: boolean;
  showTab?: boolean;
}

const NavigationFooter: FunctionComponent<IProps> = ({ showCursor, showEnter, showTab }) => (
  <div className={styles.navFooter}>
    {showCursor && (
      <div className={styles.navFooterItem}>
        <div className={styles.navFooterBtn}>▲</div>
        <div className={styles.navFooterBtn}>▼</div>
        <FormattedMessage id="nav.toMove" defaultMessage="to move" />
      </div>
    )}
    {showEnter && (
      <div className={styles.navFooterItem}>
        <div className={styles.navFooterBtn}><FormattedMessage id="enter" defaultMessage="enter" /></div>
        <FormattedMessage id="nav.toSelect" defaultMessage="to select" />
      </div>
    )}
    {showTab && (
      <div className={styles.navFooterItem}>
        <div className={styles.navFooterBtn}><FormattedMessage id="tab" defaultMessage="tab" /></div>
        <FormattedMessage id="nav.toAdvance" defaultMessage="to advance to next cell" />
      </div>
    )}
  </div>
);

export default NavigationFooter;
